var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._b({
    staticClass: "cm-truncated-text"
  }, 'div', _vm.$attrs, false), [_c('div', {
    staticClass: "cm-truncated-text__truncator",
    style: ({
      webkitLineClamp: _vm.maxLines,
      height: (_vm.snappedHeight + "px")
    })
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f800db7","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cm-truncated-text.vue
// module id = null
// module chunks = 